import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete Post">
      <div className="text-center">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
          <AlertTriangle className="h-6 w-6 text-red-600" />
        </div>
        
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Are you sure you want to delete this post?
        </h3>
        
        <p className="text-sm text-gray-500 mb-6">
          This action cannot be undone. Your post, along with all its likes and comments, will be permanently deleted.
        </p>
        
        <div className="flex space-x-3">
          <Button
            variant="outline"
            onClick={onClose}
            fullWidth
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            fullWidth
            isLoading={isDeleting}
            className="bg-red-600 hover:bg-red-700 focus:ring-red-500"
          >
            Delete Post
          </Button>
        </div>
      </div>
    </Modal>
  );
};